/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  Heading,
  Flex,
  FormControl,
  FormLabel,
  Button,
} from "@chakra-ui/react";
import { BiUserCircle } from "react-icons/bi";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { useGetUserDetails } from "../../services/auth-api";

export default function UserDetails() {
  const [user, setUser] = useState({});
  const params = useParams();

  const {
    mutate: getUserDetails,
    data: userDetailsRes,
    isPending: gettingUserDetails,
  } = useGetUserDetails();
  useEffect(() => {
    if (userDetailsRes) {
      setUser(userDetailsRes.data);
    }
  }, [userDetailsRes]);
  useEffect(() => {
    if (params.userId) {
      getUserDetails(params.userId);
    }
  }, []);
  return (
    <>
      {gettingUserDetails ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Users", link: Paths.users },
            { text: "User Details", isCurrentPage: true },
          ]}
        />

        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <form className="details-form">
              {user.firstName ? (
                <CardBody>
                  <Flex
                    as={Heading}
                    flexDirection="row"
                    gap="16px"
                    align="center"
                  >
                    <BiUserCircle />
                    <Flex flexDirection="column">
                      {user.firstName}&nbsp;{user.lastName}
                      <p style={{ fontSize: "12px", color: "var(--accent-4)" }}>
                        {user.userName}
                      </p>
                    </Flex>
                    <Button as={Link} to={`${Paths.editUser}/${user.userId}`}>
                      Edit
                    </Button>
                    <Flex flexDirection="column" marginLeft="auto">
                      <p style={{ fontSize: "14px" }}>{user.designation}</p>
                      <p style={{ fontSize: "12px", color: "var(--accent-4)" }}>
                        {user.status}
                      </p>
                    </Flex>
                  </Flex>
                  <Heading style={{ fontSize: "16px", margin: "25px 0" }}>
                    Personal Information
                  </Heading>

                  <Flex className="form-details-row">
                    <FormControl>
                      <FormLabel>First Name</FormLabel>
                      <Heading>{user.firstName}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Last Name</FormLabel>
                      <Heading>{user.lastName}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Mobile Number</FormLabel>
                      <Heading>{user.mobileNo}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Personal Mobile Number</FormLabel>
                      <Heading>{user.personalMobileNo || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Email Address</FormLabel>
                      <Heading>{user.email}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Personal Email Address</FormLabel>
                      <Heading>{user.personalEmail || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Date Of Birth</FormLabel>
                      <Heading>{user.dateOfBirth || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Nationality</FormLabel>
                      <Heading>{user.nationality || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>National Id</FormLabel>
                      <Heading>{user.nationalId || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>National Id Expiry</FormLabel>
                      <Heading>{user.nationalIdExpiry || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Passport Number</FormLabel>
                      <Heading>{user.passportNo || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Passport Expiry</FormLabel>
                      <Heading>{user.passportExpiry || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Driving License Number</FormLabel>
                      <Heading>{user.drivingLicenseNo || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Driving License Expiry</FormLabel>
                      <Heading>{user.drivingLicenseExpiry || ""}</Heading>
                    </FormControl>
                  </Flex>

                  <Heading style={{ fontSize: "16px", margin: "25px 0" }}>
                    Employee Information
                  </Heading>
                  <Flex className="form-details-row">
                    <FormControl>
                      <FormLabel>User Name</FormLabel>
                      <Heading>{user.userName || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Employee Id</FormLabel>
                      <Heading>{user.employeeId}</Heading>
                    </FormControl>

                    <FormControl>
                      <FormLabel>Designation</FormLabel>
                      <Heading>{user.designation || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Roles</FormLabel>
                      <Heading>
                        {user.roles.map(
                          (role, index) => `${index === 0 ? "" : ","}${role}`,
                        )}
                      </Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Date Of Joining</FormLabel>
                      <Heading>{user.dateOfJoining || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Office Id</FormLabel>
                      <Heading>{user.officeId || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Office Name</FormLabel>
                      <Heading>{user.officeName || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Status</FormLabel>
                      <Heading>{user.status || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Account Type</FormLabel>
                      <Heading>{user.accountType || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Assignment</FormLabel>
                      <Heading>{user.assignment || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Cash Center</FormLabel>
                      <Heading>{user.cashCenter || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Cash Center Id</FormLabel>
                      <Heading>{user.cashCenterId || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Client Id</FormLabel>
                      <Heading>{user.clientId || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Staff Type</FormLabel>
                      <Heading>{user.staffType || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Business Unit</FormLabel>
                      <Heading>{user.businessUnit || ""}</Heading>
                    </FormControl>

                    <FormControl>
                      <FormLabel>State</FormLabel>
                      <Heading>{user.state || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>City</FormLabel>
                      <Heading>{user.city || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Emirate</FormLabel>
                      <Heading>{user.emirate || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Manager Id</FormLabel>
                      <Heading>{user.managerId || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Regulatory Id</FormLabel>
                      <Heading>{user.regulatoryId || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Requested By</FormLabel>
                      <Heading>{user.requestedBy || ""}</Heading>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Comments</FormLabel>
                      <Heading>{user.comments || ""}</Heading>
                    </FormControl>
                  </Flex>
                </CardBody>
              ) : (
                <Heading />
              )}
            </form>
          </Card>
        </Flex>
      </div>
    </>
  );
}
